/** Специальный action для определения значений по-умолчанию
 * Определяет graph, текущий язык */
const Linker = {
    EMPTY: () => ({
        type: "Linker.EMPTY"
    }),
    //view - вид представления, s - IRI субъекта, триплеты которого фиксируют содержиме связи
    SHOW: (view, s) => ({
        type: "Linker.SHOW",
        view, s
    }),
    //p - predicat, o - object
    LINK: (p, o) => ({
        type: "Linker.LINK",
        o, p
    }),
    //p - predicat, o - object выбранного элемента, label - метка для отображения
    SELECTED: (p, o, label) => ({
        type: "Linker.SELECTED",
        o, p, label
    }),

    show: (iri, view=[]) => dispatch => {
        return dispatch(Linker.SHOW(view, iri));
    },

}

export default Linker;
